module.exports = __webpack_public_path__ + "static/media/fast-forward.b61c5709.png";